{
  "help": "Pomoć",
  "info": "Informacije"
}
